export default "__VITE_ASSET__a9e288fe__"